import { SelectOptionT, UserT } from "../../models/models";

/**
 * Only If the current login user is related to client “לפם” ID=1035,
 * the list of post-production companies will include all the active clients of type post-production,
 * the same as we have now.
 *
 * But for all other users, advertising agencies users, or delivery services users,
 * that are not related to the client ID 1035, the list of post-production companies
 * should not include the display of the client ID 1694 (9TV Post Production).
 *
 * The reason for that is that the business interaction between the advertising agency client 1035
 * and the post-production client 1694 is unique and only this client needs to interact with Chanel 9TV
 * as a post-production user, while for all the rest of the users,
 * it is just a source for confusion and misunderstanding.
 */

const CLIENT_TO_SHOW_9TV_POST_PROD = 1035;
const POST_PROD_CLIENT_ID_9TV = 1694;

const filterPostProdList = (item: SelectOptionT, currentUser: UserT) => {
  if (+currentUser.id !== CLIENT_TO_SHOW_9TV_POST_PROD) {
    return item.value !== POST_PROD_CLIENT_ID_9TV;
  } else {
    return true;
  }
};

export default filterPostProdList;
